import { Box, Grid, Stack, IconButton, Divider } from "@mui/material";
import CustomText from "../components/CustomText";
import CustomTextField from "../components/CustomTextField";
import CustomButton from "../components/CustomButton";
import { trackEvent } from "../utils/analytics";
import { openWhatsApp } from "../utils/openWhatsApp";
import { useFormValidation } from "../hooks/useFormValidation";
import { FaEnvelope, FaFacebookF, FaInstagram, FaPhone, FaWhatsapp } from "react-icons/fa";

const FormOurServices = () => {
  const { formData, errors, handleChange, resetForm } = useFormValidation({
    nombre: "",
    apellido_paterno: "",
    apellido_materno: "",
    correo_electronico: "",
    telefono: "",
    mensaje: "",
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    const mensaje = `Hola Centro Médico Medam 👋
Me gustaría recibir información sobre sus servicios.

*Nombre:* ${formData.nombre}
*Teléfono:* ${formData.telefono}
*Mensaje:* ${formData.mensaje}`;

    trackEvent("whatsapp_formulario_servicios", {
      page_path: window.location.pathname,
      page_url: window.location.href,
      section: "formulario_servicios",
      label: "Formulario Servicios",
      cta_name: "enviar_whatsapp",
      message_type: "contacto_general",
      value: 1,
    });

    openWhatsApp("5959570961", mensaje, false);

    resetForm();
  };

  return (
    <Grid container sx={design.Container}>
      <Grid item size={design.grid1} />
      <Grid item size={design.grid5} pr={5}>
        <CustomText
          color="#7A2FA4"
          fontWeight={700}
          letterSpacing="3px"
          textTransform="uppercase"
          mb={2}
          fontFamily="Nunito"
          fontSize={design.fontSize12}
          textAlign="left"
          width="100%"
        >
          CONTÁCTANOS
        </CustomText>
        <CustomText
          color="#162E84"
          fontWeight={800}
          fontFamily="Nunito"
          textAlign="left"
          fontSize={design.fontSize40}
          lineHeight="normal"
        >
          ¿Quieres saber más sobre
          <br />
          nuestros servicios?
        </CustomText>
        <CustomText
          color="#8A8A8A"
          fontFamily="Nunito"
          fontSize={17}
          fontWeight={400}
          textAlign="left"
          py={3}
        >
          Déjanos tus datos y nuestro equipo te contactará con la información
          que necesitas. Tu tranquilidad es nuestra prioridad.
        </CustomText>
        <Box component="form" onSubmit={handleSubmit} style={design.Card}>
          <Grid container rowGap={2.5}>
            <CustomTextField
              title=""
              id="nombre"
              name="nombre"
              label="Nombre"
              type="text"
              value={formData.nombre}
              onChange={(e) => handleChange("nombre", e.target.value)}
              variant="outlined"
              gridXS={12}
              grid={4}
              required
            />
            <CustomTextField
              title=""
              id="apellido_paterno"
              name="apellido_paterno"
              label="Apellido paterno"
              type="text"
              value={formData.apellido_paterno}
              onChange={(e) => handleChange("apellido_paterno", e.target.value)}
              variant="outlined"
              grid={4}
              gridXS={12}
              required
            />
            <CustomTextField
              title=""
              id="apellido_materno"
              name="apellido_materno"
              label="Apellido materno"
              type="text"
              value={formData.apellido_materno}
              onChange={(e) => handleChange("apellido_materno", e.target.value)}
              variant="outlined"
              grid={4}
              gridXS={12}
              required
            />
            <CustomTextField
              title=""
              id="correo"
              name="correo"
              label="Correo electrónico"
              type="email"
              value={formData.correo_electronico}
              onChange={(e) =>
                handleChange("correo_electronico", e.target.value)
              }
              variant="outlined"
              grid={6}
              gridXS={12}
              sx={design.Grid}
              width="99%"
              required
              error={!!errors.correo_electronico}
              helperText={errors.correo_electronico}
            />
            <CustomTextField
              id="telefono"
              name="telefono"
              label="Teléfono"
              title=""
              type="tel"
              value={formData.telefono}
              onChange={handleChange}
              grid={6}
              gridXS={12}
              variant="outlined"
              required
              error={!!errors.telefono}
              helperText={errors.telefono}
            />
            <CustomTextField
              id="mensaje"
              name="mensaje"
              label="Escribe tu mensaje"
              title=""
              type="text"
              value={formData.mensaje}
              onChange={handleChange}
              grid={12}
              gridXS={12}
              rows={4}
              multiline
              variant="outlined"
            />
          </Grid>
          <CustomButton
            type="submit"
            variant="contained"
            color="success"
            colorTexto="#FFF"
            backgroundColor="#489E4D"
            width="50%"
            height={50}
            grid={12}
            gridXS={12}
            borderRadius={20}
            style={design.Buttom}
            align
          >
            Enviar mensaje
          </CustomButton>
        </Box>
      </Grid>
      <Grid item size={design.grid5}>
        <Box sx={design.ContactCard}>
          <CustomText
            color="#FFFFFF"
            fontWeight={800}
            fontFamily="Nunito"
            textAlign="left"
            fontSize={design.fontSize35}
          >
            Encuéntranos también aquí
          </CustomText>
          <CustomText
            color="#FFFFFF"
            fontFamily="Nunito"
            fontSize={19}
            lineHeight={1.7}
            textAlign="left"
            mb={2}
          >
            Siguenos en redes y escríbenos cuando lo necesites.
          </CustomText>
          <CustomText
            color="#FFFFFF"
            textAlign="left"
            fontWeight={600}
            fontFamily="Nunito"
            letterSpacing="1px"
            fontSize={14}
            mb={1}
          >
            REDES SOCIALES
          </CustomText>
          <Stack direction="row" sx={design.socialMedia}>
            {redesSociales.map((red, index) => (
              <IconButton
                key={index}
                sx={design.IconButton}
                onClick={() => {
                  window.open(
                    red.url,
                    red.url.startsWith("http") ? "_blank" : "_self",
                  );
                }}
              >
                {red.icon}
              </IconButton>
            ))}
          </Stack>
          <CustomText
            color="#DCDCDC"
            textAlign="left"
            fontWeight={600}
            fontFamily="Nunito"
            letterSpacing="1px"
            fontSize={14}
            mb={1}
          >
            TELÉFONOS
          </CustomText>
          <Stack spacing={2} mt={2}>
            <Box sx={design.PhoneRow}>
              <FaWhatsapp style={design.PhoneIcon} />
              <CustomText
                color="#FFF"
                fontSize={17}
                fontFamily="Nunito"
                fontWeight={500}
                textAlign="left"
              >
                55 0000 0000
              </CustomText>
            </Box>
            <Box sx={design.PhoneRow}>
              <FaPhone style={design.PhoneIcon} />
              <CustomText
                color="#FFF"
                fontSize={17}
                fontFamily="Nunito"
                fontWeight={500}
                textAlign="left"
              >
                +52 595 957 0961
              </CustomText>
            </Box>
          </Stack>
          <CustomButton
            backgroundColor="#58B947"
            colorTexto="#FFF"
            width="50%"
            height={52}
            borderRadius={20}
            style={design.Buttom}
            onClick={() =>
              openWhatsApp(
                "5959570961",
                "Hola, me gustaría recibir información sobre sus servicios.",
                false,
              )
            }
          >
            Envíanos un WhatsApp
          </CustomButton>
          <Divider sx={design.Divider} />
          <CustomText
            color="rgba(255,255,255,.90)"
            lineHeight={1.8}
            fontSize={16}
            fontFamily="Nunito"
            textAlign="left"
          >
            Centro Médico Medam, Calpulalpan-Texcoco 105, Xala, 56270 Texcoco de
            Mora, Méx.
          </CustomText>
        </Box>
      </Grid>
      <Grid item size={design.grid1} />
    </Grid>
  );
};
export default FormOurServices;

const design = {
  Container: {
    background: "#FFFFFF",
    py: {
      xs: 6,
      md: 5,
    },
  },
  Buttom: {
    fontFamily: "Nunito",
    fontSize: 16,
    marginTop: 20,
  },
  ContactCard: {
    background: "#1F3F92",
    borderRadius: "20px",
    padding: {
      xs: 2,
      md: 3,
      lg: 4,
    },
    boxShadow: "0 20px 60px rgba(0,0,0,.15)",
  },
  IconButton: {
    width: 48,
    height: 48,
    backgroundColor: "rgba(255,255,255,.12)",
    color: "#FFF",
    transition: ".25s",
    "&:hover": {
      backgroundColor: "#58B947",
      transform: "translateY(-2px)",
    },
    "& svg": {
      fontSize: 24,
    },
  },
  PhoneRow: {
    display: "flex",
    alignItems: "center",
    gap: 2,
    py: 0.5,
  },
  PhoneIcon: {
    color: "#FFFFFF",
    fontSize: 22,
  },
  socialMedia: {
    gap: 2,
    mt: 2,
    mb: 2,
  },
  Divider: {
    my: 2,
    borderColor: "#FFF",
  },
  grid1: { xs: 1, md: 1 },
  grid5: { xs: 11, md: 5, xl: 5, lg: 5 },
  fontSize12: { xs: 12, sm: 12, md: 12, lg: 12 },
  fontSize40: { xs: 35, sm: 35, md: 35, lg: 40 },
  fontSize35: { xs: 30, md: 35 },
};

const socialIconStyle = {
  fontSize: 24,
  color: "#FFF",
};

const redesSociales = [
  {
    icon: <FaInstagram sx={socialIconStyle} />,
    url: "https://www.instagram.com/centromedico_medam?igsh=ajhiYnFmenJjMXBo",
    type: "instagram",
  },
  {
    icon: <FaFacebookF sx={socialIconStyle} />,
    url: "https://www.facebook.com/share/19EGRopCww/?mibextid=wwXIfr",
    type: "facebook",
  },
  {
    icon: <FaEnvelope sx={socialIconStyle} />,
    url: "mailto:contacto@centromedicomedam.com",
    type: "mail",
  },
];
